import React from "react";

export default function PoweredBy() {
  return (
    <div style={{border:"2px solid #184CCF", width:'fit-content',padding:"4px 12px",borderRadius:"15px",background:'white'}}>
       <span style={{ fontSize:"1em"}}>Powered by {" "}</span>
      <span style={{ color: "#FF2618" ,fontSize:"1em",fontWeight:"600"}}>COM</span>
      <span style={{ color: "#3E74D0",fontSize:"1em",fontWeight:"600" }}>DATA</span>
    </div>
  );
}
